(() => {
 const root=document.querySelector('main');
 if(!root||!document.body.classList.contains('mp-catalog-page'))return;
 if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 const selector='.mp-collection-banner,.mp-category-nav,.product-grid__item,media-gallery,.product-information__media,.product-details';
 const seen=new WeakSet();
 const observer=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting){entry.target.classList.add('mp-catalog-shown');observer.unobserve(entry.target);}}},{threshold:.08});
 const register=()=>root.querySelectorAll(selector).forEach((el,i)=>{if(seen.has(el))return;seen.add(el);el.classList.add('mp-catalog-reveal');el.style.setProperty('--mp-catalog-delay',Math.min(i%4*.08,.24)+'s');observer.observe(el);});
 register();
 let pending=false;
 new MutationObserver(()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;register();});}).observe(root,{childList:true,subtree:true});
})();
